import React, { PureComponent, Fragment } from 'react'
// import { Button, ButtonGroup } from '@material-ui/core'

import ExistingFilter from 'bundles/Dashboard/components/ExistingFilter';
import PipelineFilter from 'bundles/Dashboard/components/PipelineFilter';

class Filters extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            existingOrPipeline : 1
        }
    }

    setFilterView = (existingOrPipeline) => {
   
        this.setState({ existingOrPipeline })

    }

    render() {
        const {
            filters: {
                risk,
                ami,
                funding,
                population,
                housing,
                stewarding,
                minSubUnits,
                maxSubUnits,
                minPerUnitSub,
                maxPerUnitSub,
                subStartDateBegin,
                subStartDateEnd,
                subEndDateBegin,
                subEndDateEnd,

                
               
            },
            switchesInFilter:{
                tenure,
                affordabilityThreshold,
                afforabilityTerm,
                construction,
                permanentSupportativeHousing,
                communityLandTrust,
                greenCertified,
                innovation,
                nonprofit,
                bIPOC,
                families,
                seniors,
                formerlyHomeless,
            },
            handleChange,
            handleFilterChangePipeline,
            makeDateHandler,
            onSubmit,
            onReset,
            onSubmitPipeline,
            onResetPipeline
        } = this.props;

        const {
            existingOrPipeline
        } = this.state;

        

        return (
            <Fragment>
               {/* <div className="top-bar-filter"> */}
                    {/* <ButtonGroup 
                        variant="contained" 
                        style={{ width: '100%',padding: '12px 20px', boxShadow: '0px -1px 0px rgba(221, 221, 221, 0.75)' }}>
                        <Button
                            className={existingOrPipeline === 1 ? 'selected' : ''}
                            style={{ width: '100%',backgroundColor: '#d82238',color:'white' }}
                            onClick={() => this.setFilterView(1)}
                        >
                            existing
                        </Button>
                        <Button
                            className={existingOrPipeline === 0 ? 'selected' : ''}
                            style={{ width: '100%',backgroundColor: 'rgba(115,173,150,255)',color:'white'}}
                            onClick={() => this.setFilterView(0)}
                        >
                            pipeline
                        </Button>
                    </ButtonGroup> */}
                {/* </div> */}
            
                {existingOrPipeline === 1 ? (
                    <ExistingFilter
                        risk = {risk}
                        minSubUnits = {minSubUnits}
                        maxSubUnits = {maxSubUnits}
                        minPerUnitSub = {minPerUnitSub}
                        maxPerUnitSub = {maxPerUnitSub}
                        subStartDateBegin = {subStartDateBegin}
                        subStartDateEnd = {subStartDateEnd}
                        subEndDateBegin = {subEndDateBegin}
                        subEndDateEnd = {subEndDateEnd}
                        handleChange={handleChange}
                        makeDateHandler={makeDateHandler}
                        ami = {ami}
                        funding = {funding}
                        population = {population}
                        housing = {housing}
                        stewarding = {stewarding}
                        onSubmit={onSubmit}
                        onReset ={onReset}
                    />
                ): (
                    <PipelineFilter
                        tenure = {tenure}
                        affordabilityThreshold = {affordabilityThreshold}
                        afforabilityTerm = {afforabilityTerm}
                        construction= {construction}
                        permanentSupportativeHousing= {permanentSupportativeHousing}
                        communityLandTrust= {communityLandTrust}
                        greenCertified= {greenCertified}
                        innovation= {innovation}
                        nonprofit= {nonprofit}
                        bIPOC= {bIPOC}
                        families= {families}
                        seniors= {seniors}
                        formerlyHomeless= {formerlyHomeless}
                        handleFilterChangePipeline = {handleFilterChangePipeline}
                        onSubmitPipeline={onSubmitPipeline}
                        onResetPipeline ={onResetPipeline}
                    />
                )}
            </Fragment>
        )
    }
}

export default Filters